import FetchWrapper from './FetchWrapper'
import { ServiceHealth } from '../models/ServiceHealth'

class BB20Service {
  serviceUrl: string

  constructor(url: string) {
    this.serviceUrl = url
  }

  health(): Promise<ServiceHealth> {

    let urlBasePart
    // the core service should be used for the health endpoint as well: http://localhost:8083/core-service/actuator/health
    if (this.serviceUrl.includes('core-service')) {
      urlBasePart = this.serviceUrl
      // Workaround only for local development
      if (process.env.REACT_APP_ENV === 'local') {
        urlBasePart = `${urlBasePart}/core-service`
      }
    } else {
      urlBasePart = this.serviceUrl.slice(
        0,
        this.serviceUrl.lastIndexOf('/')
      )
    }
    const healthUrl = `${urlBasePart}/actuator/health`
    return FetchWrapper.GET(healthUrl)
  }

  getSwaggerUrl(): string {
    const urlBasePart = this.serviceUrl.slice(
      0,
      this.serviceUrl.lastIndexOf('/')
    )
    return `${urlBasePart}/swagger-ui.html`
  }

  getJavaMelodyUrl(): string {
    const urlBasePart = this.serviceUrl.slice(
      0,
      this.serviceUrl.lastIndexOf('/')
    )
    return `${urlBasePart}/monitoring`
  }
}

export default BB20Service
